"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MarkerCamChip = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _pittaModules = require("@thingsw/pitta-modules");
var _DashCam = require("../icons/DashCam");
var _Person = _interopRequireDefault(require("@material-ui/icons/Person"));
var _DriveEta = _interopRequireDefault(require("@material-ui/icons/DriveEta"));
var _LocalParking = _interopRequireDefault(require("@material-ui/icons/LocalParking"));
var _excluded = ["color", "variant", "cam", "$hover", "$getDimensions", "$dimensionKey", "$geoService", "$onMouseAllow", "$prerender", "lat", "lng"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var useStyle = (0, _styles.makeStyles)({
  root: {
    height: 30,
    width: 26,
    borderRadius: 0,
    position: "relative",
    filter: "drop-shadow(0px 0px 1px rgba(0, 0, 0, 0.14))\n      drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.12)) \n      drop-shadow(0px 0px 3px rgba(0, 0, 0, 0.2))"
  },
  eillps: {
    position: "absolute",
    width: 24,
    height: 24,
    borderRadius: "50%",
    top: 6,
    left: 0,
    backgroundColor: function backgroundColor(props) {
      return props.variant === "car" ? _pittaModules.LightColors.primary["0"] : props.variant === "outpark" ? _pittaModules.LightColors.primary["0"] : props.color === "primary" ? _pittaModules.LightColors.primary["7"] : _pittaModules.LightColors.secondary["11"];
    },
    border: function border(props) {
      return props.variant === "car" ? "1px solid ".concat(_pittaModules.LightColors.primary["7"]) : props.variant === "outpark" ? "1px solid ".concat(_pittaModules.LightColors.primary["7"]) : "1px solid ".concat(_pittaModules.LightColors.primary["0"]);
    },
    boxSizing: "border-box"
  },
  psersonIcon: {
    position: "absolute",
    fontSize: 16,
    top: 3,
    left: 3,
    color: _pittaModules.LightColors.primary["0"]
  },
  carIcon: {
    position: "absolute",
    fontSize: 16,
    top: 3,
    left: 3,
    color: _pittaModules.LightColors.primary["7"]
  },
  parkIcon: {
    position: "absolute",
    fontSize: 16,
    top: 3,
    left: 3,
    color: function color(props) {
      return props.variant === "outpark" ? _pittaModules.LightColors.primary["7"] : _pittaModules.LightColors.primary["0"];
    }
  },
  cam: {
    position: "absolute",
    fontSize: 16,
    height: 10,
    top: 1,
    left: 9
  }
});
var MarkerCamChip = function MarkerCamChip(props) {
  var classes = useStyle(props);
  var color = props.color,
    variant = props.variant,
    cam = props.cam,
    $hover = props.$hover,
    $getDimensions = props.$getDimensions,
    $dimensionKey = props.$dimensionKey,
    $geoService = props.$geoService,
    $onMouseAllow = props.$onMouseAllow,
    $prerender = props.$prerender,
    lat = props.lat,
    lng = props.lng,
    restProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement("div", _extends({
    className: classes.eillps
  }, restProps), variant === "person" && /*#__PURE__*/_react.default.createElement(_Person.default, {
    className: classes.psersonIcon
  }), variant === "car" && /*#__PURE__*/_react.default.createElement(_DriveEta.default, {
    className: classes.carIcon
  }), (variant === "park" || variant === "outpark") && /*#__PURE__*/_react.default.createElement(_LocalParking.default, {
    className: classes.parkIcon
  })), cam && /*#__PURE__*/_react.default.createElement(_DashCam.DashCam, {
    className: classes.cam
  })));
};
exports.MarkerCamChip = MarkerCamChip;